/* Custom mega menu behaviour: click to open/close, hover/focus/click to switch tabs. */
(function () {
  function init() {
    var nav = document.querySelector('.cmm');
    if (!nav || nav.dataset.ready) return;
    nav.dataset.ready = '1';
    var triggers = nav.querySelectorAll('.cmm__trigger');

    function closeAll(except) {
      triggers.forEach(function (t) {
        if (t === except) return;
        t.setAttribute('aria-expanded', 'false');
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = true;
      });
    }

    triggers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = t.getAttribute('aria-expanded') === 'true';
        closeAll(t);
        t.setAttribute('aria-expanded', open ? 'false' : 'true');
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = open;
      });
    });

    nav.querySelectorAll('.cmm__tab').forEach(function (tab) {
      function activate() {
        var key = tab.dataset.tab;
        var scope = tab.closest('.cmm__tabs');
        scope.querySelectorAll('.cmm__tab').forEach(function (x) { x.classList.toggle('is-active', x === tab); });
        scope.querySelectorAll('.cmm__tabpanel').forEach(function (x) { x.classList.toggle('is-active', x.dataset.panel === key); });
      }
      tab.addEventListener('mouseenter', activate);
      tab.addEventListener('focus', activate);
      tab.addEventListener('click', activate);
    });

    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target)) closeAll();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }
  // Mobile drawer accordions (event delegation, works after drawer re-renders)
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('.cmm-m__toggle') : null;
    if (!t) return;
    var open = t.getAttribute('aria-expanded') === 'true';
    t.setAttribute('aria-expanded', open ? 'false' : 'true');
    var p = document.getElementById(t.getAttribute('aria-controls'));
    if (p) p.hidden = open;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
